import React from 'react';
import { Map } from 'immutable';
import { TypedMap } from 'flow/types/TypedMap';
import { Favorite } from 'flow/types/Favorite';
import { ContactKey, ExtensionKey } from 'flow/types/EntityKeys';
import { useAppSelector } from 'flow/hooks/useRedux';
import ListItemContact from 'flow/components/ui-components/ListItemContact';
import { selectContactByKey } from 'flow/selectors/contact-selectors';
import { selectExtension } from 'flow/selectors/ExtensionSelectors';

type Props = {
    favorite: TypedMap<Favorite>;
};

const FavoriteItem = ({ favorite }: Props) => {
    const favoriteType = favorite.get('type');
    const extensionKey =
        favoriteType === 'extension'
            ? (favorite.getIn(['favoriteData', 'key']) as ExtensionKey)
            : undefined;
    const contactKey =
        favoriteType === 'contact'
            ? (favorite.getIn(['favoriteData', 'key']) as ContactKey)
            : undefined;

    const extension = useAppSelector((state) =>
        extensionKey ? selectExtension(state, extensionKey) : undefined,
    );
    const liveContact = useAppSelector((state) =>
        contactKey ? selectContactByKey(state, contactKey) : undefined,
    );

    if (favoriteType === 'extension') {
        return (
            <ListItemContact
                contact={extension?.get('contact', Map())}
                contactType="extension"
                extensionKey={extensionKey}
            />
        );
    }

    if (favoriteType === 'contact') {
        return (
            <ListItemContact
                contact={liveContact || favorite.get('favoriteData')}
                contactType="externalContacts"
            />
        );
    }

    if (favoriteType === 'socialIntegrationContacts') {
        return (
            <ListItemContact
                contact={favorite.get('favoriteData')}
                contactType="socialIntegrationContacts"
            />
        );
    }

    return null;
};

export default FavoriteItem;
